import React, { useState } from "react";
import VideoGuideCarousel from "../components/VideoGuideCarousel";
import { videoGuideList } from "../assets/common";

export default function UserManualPage() {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);

    const handleOpenModal = (index) => {
        setActiveIndex(index);
        setIsModalOpen(true);
    };

    return (
        <div className="max-w-6xl mx-auto px-4 py-8">
            <h1 className="text-3xl font-bold mb-6 text-center">PayPlus Kullanım Rehberi</h1>

            <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
                {videoGuideList.map((video, index) => (
                    <div
                        key={video.id}
                        className="bg-white shadow-md rounded-lg overflow-hidden cursor-pointer hover:shadow-xl transition"
                        onClick={() => handleOpenModal(index)}
                    >
                        <div className="aspect-video overflow-hidden">
                            <img
                                src={`https://img.youtube.com/vi/${video.id}/mqdefault.jpg`}
                                alt={video.title}
                                className="w-full h-full object-cover"
                            />
                        </div>
                        <div className="p-4">
                            <h2 className="text-lg font-semibold mb-1">{video.title}</h2>
                            <p className="text-sm text-gray-600 line-clamp-2">{video.description}</p>
                        </div>
                    </div>
                ))}
            </div>

            <VideoGuideCarousel
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                initialIndex={activeIndex}
            />
        </div>
    );
}
